namespace TabAurous.OMS {
    export interface ProductImagesRow {
        ProductImageId?: number;
        ProductId?: number;
        Image1?: string;
        Image2?: string;
        Image3?: string;
        Image?: string;
    }

    export namespace ProductImagesRow {
        export const idProperty = 'ProductImageId';
        export const nameProperty = 'Image1';
        export const localTextPrefix = 'OMS.ProductImages';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            ProductImageId = "ProductImageId",
            ProductId = "ProductId",
            Image1 = "Image1",
            Image2 = "Image2",
            Image3 = "Image3",
            Image = "Image"
        }
    }
}
